import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/kshAdmin/ControlCategory/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/kshAdmin/ControlCategory/create",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/kshAdmin/ControlCategory/edit",  {id:params}  )
}
function SUBMIT_ADD(params) {
    return  axios.post("/kshAdmin/ControlCategory/createPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/kshAdmin/ControlCategory/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/kshAdmin/ControlCategory/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/kshAdmin/ControlCategory/delete",{
        params: {
            ids:params
        }
    } )
}
function ORDER_LIST (params) {
    return  axios.post("/kshAdmin/ControlCategory/listOrder",{list_orders:params} )
}

export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    ORDER_LIST
}